import React from 'react';

import styled from '@emotion/styled';
import Link from 'next/link';

import ArrowRight from '@assets/Icons/ArrowRight.svg';

interface PageHeaderProps {
  icon?: any;
  title?: string;
  buttons?: JSX.Element[];
  breadcrumb?: string;
  titleLink?: string;
  className?: string;
}

const Header = styled.div`
  width: 100%;
  height: 62px;
  padding: 0.8em 1.5em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid ${(props) => props.theme.color.primary100};
`;

const SideHeading = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color.gray50};
  margin-left: 0.2em;
  font-size: 1em;
  p {
    cursor: auto;
  }
  svg {
    font-size: 0.5em;
    // margin-right: 0.5em;
    // margin-top: 0.1em;
    fill: ${(props) => props.theme.color.accent700};
  }
`;

const PageHeader = (props: PageHeaderProps): JSX.Element => {
  const Heading = styled.div`
    font-size: 1.15em;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(styledprops) =>
      props.breadcrumb
        ? styledprops.theme.color.gray800
        : styledprops.theme.color.gray50};
    p {
      text-transform: uppercase;
      margin: 0;
      line-height: 1em;
      letter-spacing: 0.4em;
      // margin-top: 0.2em;
      cursor: pointer;
    }
    svg {
      fill: currentColor;
      height: 1.5em !important;
      margin-right: 1em;
    }
  `;
  return (
    <Header className={props.className ?? ''}>
      <Heading>
        {props.icon}
        <Link
          href={props.titleLink ?? '#'}
          passHref={true}
          shallow
          legacyBehavior
        >
          <p>{props.title}</p>
        </Link>
        {props.breadcrumb && (
          <Breadcrumb>
            <ArrowRight />
            <p>{props.breadcrumb}</p>
          </Breadcrumb>
        )}
      </Heading>
      <SideHeading>{props.buttons?.map((button) => button)}</SideHeading>
      {/* <div className="view-switcher">
          <button
            onClick={() => setCurrentView('gallery')}
            className={`view-btn ${currentView === 'gallery' ? 'active' : ''}`}
          >
            <IoImageOutline /> <span>Gallery View</span>
          </button>
          <StyledDivider type="vertical" />
          <button
            onClick={() => setCurrentView('list')}
            className={`view-btn ${currentView === 'list' ? 'active' : ''}`}
          >
            <FiList /> <span>List View</span>
          </button>
        </div> */}
    </Header>
  );
};

export default PageHeader;
